export const womenKeys = {
  all: ["women"] as const,
  trips: (lang: string) => ["women", "trips", lang] as const,
  organiser: (slug: string, lang: string) => ["women", "organiser", slug, lang] as const,
};
